/**
 * Wrap up a bunch of common field mixins into a single array that we can easily
 * include in our components
 */

import computedClass from '@/mixins/computedClass'
import fieldProps from '@/mixins/fieldProps'
import showValidation from '@/mixins/showValidation'
import watch from '@/mixins/watch'
import events from '@/mixins/events'
import parentForm from '@/mixins/parentForm'
import parentSection from '@/mixins/parentSection'
import validationDictionary from '@/mixins/validationDictionary'
import validate from '@/mixins/validate'
import data from '@/mixins/data'
import meta from '@/mixins/meta'
import reset from '@/mixins/reset'
import focus from '@/mixins/focus'
import payloadValue from '@/mixins/payloadValue'

export default [
  computedClass,
  payloadValue,
  validationDictionary,
  events,
  fieldProps,
  showValidation,
  reset,
  watch,
  validate,
  data,
  meta,
  parentForm,
  parentSection,
  focus
]



// WEBPACK FOOTER //
// ./src/frontend/mixins/index.js